import { useEffect } from "react";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { useElapsed } from "../../../../utils/useElapsed";
import { useNotificationPermission } from "../../../../utils/useNotificationPermission";
const { airship } = BRAND_CONFIGURATION;
const KEY = "airship";
export const useInitAirship = () => {
    const permission = useNotificationPermission();
    const { dispatch } = useOverlayOrchestrator();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    const active = Boolean(airship && canProceed);
    const isElapsed = useElapsed({ active, duration: 15 });
    useEffect(() => {
        if (!airship && canProceed) {
            dispatch({ type: "DISABLE", payload: KEY });
        }
    }, [canProceed, dispatch]);
    useEffect(() => {
        // Airship requires the user to have made a choice on notification permission
        // If the use has made a choice, we can init right away
        // Otherwise, we wait for 15 seconds before initing Airship in the background
        const shouldInit = ["granted", "denied"].includes(permission) || isElapsed;
        if (shouldInit) {
            dispatch({ type: "INIT", payload: KEY });
        }
    }, [isElapsed, permission, dispatch]);
};
